/**
 * @param { Object } workbook
 * @return { void }
 */

export const writehtml = workbook => {
	let html = template
	let nav = ''
	for (const sheetName in workbook.Sheets) {
		try {
			const sheet = workbook.Sheets[sheetName]
			const sheetHtml = XLSX.utils.sheet_to_html(sheet)
			html += `
        <div id="${sheetName}">
          <div class="title">${sheetName}</div>
          ${sheetHtml.match(/<table>[\s\S]*<\/table>/)[0].replace('<table>', `<table id = "${sheetName}">`)}
        </div>
      `
			nav += `<a href="#${sheetName}">${sheetName}</a>`
		} catch (err) {
			console.log(err)
		}
	}
	setTimeout(() => {
		document.write(`<nav id="nav">${nav}</nav>${html}`)
		document.close()
	}, 0)
}

const XLSX = require('xlsx')

const template = `
<style type="text/css">
  html,
  body {
    margin: 0;
    padding: 0;
  }
  body {
    padding-bottom: 100px;
  }
  #nav {
    position: fixed;
    bottom: 0;
    border-top: 1px solid #cbcbcb;
    left: 0;
    line-height: 50px;
    background: #fff;
    width: 100vw;
    overflow-x: auto;
  }
  a {
    text-decoration: none;
    margin-left: 20px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    padding-left: 20px;
    height: 50px;
    line-height: 50px;
  }
  table {
    width: 100vw;
    height: 100vh;
    overflow: auto;
    border-collapse: collapse;
    border-spacing: 0;
  }
  td,
  th {
    padding: 0;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
    empty-cells: show;
    border: 1px solid #cbcbcb;
  }
  table caption {
    color: #000;
    font: italic 85%/1 arial, sans-serif;
    padding: 1em 0;
    text-align: center;
  }
  table td,
  table th {
    border-left: 1px solid #cbcbcb;
    border-bottom: 1px solid #cbcbcb;
    font-size: inherit;
    margin: 0;
    overflow: visible;
    padding: 0.5em 1em;
  }
  table thead {
    background-color: #e0e0e0;
    color: #000;
    text-align: left;
    vertical-align: bottom;
  }
  table td {
    background-color: transparent;
  }
</style>
`
